import { render } from "./FooterTextTwo.vue?vue&type=template&id=7370dfc5&scoped=true"
import script from "./FooterTextTwo.vue?vue&type=script&lang=js"
export * from "./FooterTextTwo.vue?vue&type=script&lang=js"

import "./FooterTextTwo.vue?vue&type=style&index=0&id=7370dfc5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7370dfc5"]])

export default __exports__